module.exports = __webpack_public_path__ + "static/media/scratch_prize.cac43c92.jpg";